import * as React from 'react';
import { useMemo } from 'react';

import { getOptionsOrderAndWithoutRepeatedElements } from '../../shared/helpers/validation';
import { SelectPortal } from '../SelectPortal';
import { Choices, SelectOption, SelectOptionsTransform } from './tableFilter.types';

interface SelectFiltersProps {
  choices: Choices;
  filter?: { value: string } | null;
  onChange: (value: string) => void;
  id: string;
  choicesTransform?: SelectOptionsTransform;
}

const CLEAR_OPTION: SelectOption = { key: 'none', text: <div>&mdash;</div>, value: '' };

export const buildSelectOptions = (choices: Choices, choicesTransform?: SelectOptionsTransform): SelectOption[] => {
  const options = getOptionsOrderAndWithoutRepeatedElements(choices) as unknown as SelectOption[];
  const narrowed = choicesTransform ? choicesTransform(options) : options;
  narrowed.unshift(CLEAR_OPTION);
  return narrowed;
};

export const SelectFilters = ({ choices, filter, onChange, id, choicesTransform }: SelectFiltersProps) => {
  const options = useMemo(() => buildSelectOptions(choices, choicesTransform), [choices, choicesTransform]);

  const value: string = filter ? filter.value : '';
  const handleOnChange = (data: string) => {
    onChange(data);
  };

  return <SelectPortal options={options} handle={handleOnChange} id={id} value={value} placeholder="Select" />;
};
